import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nutrition-management',
  templateUrl: './nutrition-management.component.html',
  styleUrls: ['./nutrition-management.component.scss']
})
export class NutritionManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
